import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'
import TextHeader from '@abra/elements/table/headers/Text'

const Header = () => <>
  <TableCell align='center' sx={{ minWidth: 100 }}>
    <TextHeader label={I18n.t('voucher.code')} />
  </TableCell>
  <TableCell align='center' sx={{ minWidth: 150 }}>
    <TextHeader label={I18n.t('company.label', { count: 1 })} />
  </TableCell>
  <TableCell align='center' sx={{ minWidth: 150 }}>
    <TextHeader label={I18n.t('voucher.contract_service')} />
  </TableCell>
  <TableCell align='center' sx={{ minWidth: 150 }}>
    <TextHeader label={I18n.t('date.period')} />
  </TableCell>
  <TableCell align='center' sx={{ width: 90 }}>
    <TextHeader label={I18n.t('voucher.max_user_usage')} />
  </TableCell>
  <TableCell align='center' sx={{ width: 90 }}>
    <TextHeader label={I18n.t('voucher.max_global_usage')} />
  </TableCell>
  <TableCell align='center' sx={{ width: 80 }}>
    <TextHeader label={I18n.t('voucher.amount')} />
  </TableCell>
  <TableCell align='center' sx={{ width: 80 }}>
    <TextHeader label={I18n.t('status.label', { count: 1 })} />
  </TableCell>
  <TableCell align='center' sx={{ width: 100 }}>
    <TextHeader label={I18n.t('date.label', { count: 1 })} />
  </TableCell>
  <TableCell align='center' sx={{ minWidth: 120 }}>
    <TextHeader label={I18n.t('voucher.createdBy')} />
  </TableCell>
</>

export default React.memo(Header)
